import React, { useEffect, useRef, useState } from "react";

export default function RoadmapSection() {
  const ref = useRef(null);

  // Scroll reveal animation
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add("is-visible");
            io.unobserve(en.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  const cards = [
    {
      title: "Phase One",
      desc: "Our first objective is to establish a reserve backing Synergy Coin with real-world assets, including U.S. Treasury bills, bonds, ETFs, and real estate. ",
      detail:
        "Our first objective is to establish a reserve backing Synergy Coin with real-world assets, including U.S. Treasury bills, bonds, ETFs, and real estate. This reserve is designed to provide tangible value and stability for community members holding our coin.As part of Phase One, Synergy Coin will launch its Initial Token Offering (ITO) with plans to list on three U.S.-based exchanges: Robinhood, Crypto.com, and Coinbase.Simultaneously, our development team is building the Synergy Marketplace using an AI-driven platform designed to identify high-traffic business districts, restaurants, and farmers markets to strengthen local connections and broaden community engagement.",
    },
    {
      title: "Phase Two",
      desc: "In the second phase, Synergy Coin Inc. aims to become a bridge between the cryptocurrency community and traditional financial systems.",
      detail:
        "In the second phase, Synergy Coin Inc. aims to become a bridge between the cryptocurrency community and traditional financial systems. We will build a Financial Resource Hub to assist community members who may lack access to conventional financing options. Through strategic partnerships and tailored financial pathways, our goal is to open doors that were previously out of reach—while staying firmly aligned with our core mission of supporting our community and their long-term success.We stand behind our coin and our community.",
    },
    {
      title: "Phase Three",
      desc: "Our long-term vision is to transition Synergy Coin Inc. into a publicly traded company.",
      detail:
        "Our long-term vision is to transition Synergy Coin Inc. into a publicly traded company. As a startup with ambitious goals, we are committed to expanding one neighborhood at a time and offering opportunities typically accessible only to early-stage investors.",
    },
  ];
  const [selectedCard, setSelectedCard] = useState(null);

  const introText =
    "Cryptocurrency has evolved from a simple peer-to-peer electronic cash concept into a multi-trillion-dollar global industry since its emergence in 2009. Experts predict that the market may grow by an additional $5 to $10 trillion over the next decade. While the industry continues to expand, the challenge lies not in its growth, but in enabling individuals to participate meaningfully and confidently in that growth. Today, hundreds of thousands of cryptocurrencies trade across numerous exchanges. For newcomers and even experienced investors, distinguishing between coins with real utility and those created purely for hype or entertainment can be overwhelming. In many ways, the original vision of cryptocurrency as a true peer-to-peer currency has been overshadowed by speculation. Synergy Coin aims to return to these foundational principles by placing the emphasis back on currency. We are building a marketplace where Synergy Coin will serve as an active medium of exchange—used alongside the U.S. dollar. The Synergy Marketplace will support local entrepreneurs, small business owners, neighborhood restaurants, and farmers markets. With the help of our Synergy marketing partners across different regions, along with our community-driven affiliate and referral programs, we aim to grow organically from neighborhood to neighborhood, ultimately reaching communities across the nation.";

  const closeModal = () => setSelectedCard(null);

  return (
    <section ref={ref} className="text-white mt-12 md:pb-32 overflow-hidden">
      <div className="mx-auto flex max-w-8xl flex-col gap-4 px-0 sm:px-6 lg:px-0">
        {/* Heading and Description */}
        <div className="space-y-4 text-left">
          <h2 className="reveal translate-y-6 opacity-0 text-4xl font-extrabold tracking-tight text-[#EBD3FF] sm:text-5xl transition-all duration-700 delay-100">
            Investors Guide
          </h2>
          <p className="reveal max-w-5xl translate-y-6 opacity-0 text-base leading-7 text-[#C5D2DF] transition-all duration-700 delay-200">
            {introText}
          </p>
        </div>

        {/* Roadmap Cards */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {cards.map((c, i) => (
            <div
              key={c.title}
              style={{ transitionDelay: `${250 + i * 120}ms` }}
              className="reveal relative flex flex-col translate-y-6 opacity-0 rounded-2xl bg-white/5 p-6 text-left shadow-[0_10px_40px_rgba(0,0,0,0.5)] backdrop-blur-md transition-[transform,opacity,box-shadow] duration-700 hover:-translate-y-2 hover:shadow-[0_20px_50px_rgba(160,110,255,0.5)]"
            >
              <div className="pointer-events-none absolute inset-0 -z-10 rounded-2xl bg-[radial-gradient(120%_60%_at_50%_10%,rgba(255,255,255,0.10),transparent_55%)]" />
              <div className="flex flex-col flex-1">
                <h3 className="text-2xl font-semibold">{c.title}</h3>
                <p
                  className="mt-3 text-sm leading-6 text-[#C5D2DF]"
                  style={{
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitLineClamp: 4,
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {c.desc}
                </p>
              </div>
              <button
                type="button"
                onClick={() => setSelectedCard(c)}
                className="mt-5 inline-flex w-full items-center justify-center rounded-full border border-white/30 bg-white/5 px-4 py-2 text-sm font-semibold text-white transition hover:border-white hover:bg-white/10 whitespace-nowrap"
              >
                Read more
              </button>
              {/* data */}
            </div>
          ))}
        </div>
        {selectedCard && (
          <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-4"
            role="dialog"
            aria-modal="true"
          >
            <div className="max-w-3xl rounded-3xl border border-white/20 bg-[#0B0C10] p-10 shadow-[0_25px_70px_rgba(0,0,0,0.75)]">
              <div className="flex items-center justify-between">
                <h3 className="text-2xl font-semibold text-white">
                  {selectedCard.title}
                </h3>
                <button
                  type="button"
                  onClick={closeModal}
                  className="text-white/50 transition hover:text-white"
                  aria-label="Close modal"
                >
                  
                </button>
              </div>
              <p className="mt-4 text-sm leading-7 text-white/80">
                {selectedCard.detail}
              </p>
              <button
                type="button"
                onClick={closeModal}
                className="mt-6 rounded-full border border-white/30 px-5 py-2 text-sm font-semibold text-white transition hover:border-white hover:bg-white/10"
              >
                Close
              </button>
            </div>
          </div>
        )}
        <div className="pb-24 sm:pb-0"></div>

        {/* Background Video Section (Hidden on Mobile) */}
        <div className="hidden md:block relative overflow-hidden rounded-3xl  h-[35vh] lg:h-[60vh]">
          <div className="flex justify-center items-center w-full pl-10">
            <video
              className="h-full max-w-[1300px] w-full object-cover rounded-3xl"
              src="/images/video-main.mp4"
              autoPlay
              loop
              muted
              playsInline
              ref={(video) => {
                if (video) video.playbackRate = 0.7;
              }}
            />
          </div>
          <div className="pointer-events-none absolute inset-0 bg-black/20 rounded-3xl" />
        </div>
      </div>
    </section>
  );
}
